export default __webpack_public_path__ + "static/media/seeting.454d50fe.png";